import React from 'react';
import { ThemeProvider } from 'styled-components';
import { GlobalStyles } from './styles/GlobalStyles';
import { theme } from './styles/theme';
import { LightweightPerformanceProvider } from './contexts/PerformanceContext';
import { NavigationProvider } from './contexts/NavigationContext';
import PageWrapper from './components/Layout/PageWrapper';

import Header from './components/Layout/Header';
import Hero from './components/Sections/Hero';
import Countdown from './components/Sections/Countdown';
import About from './components/Sections/About';
import Speakers from './components/Sections/Speakers';
import EventDetails from './components/Sections/EventDetails';
import Sponsors from './components/Sections/Sponsors';
import HackingVillage from './components/Sections/HackingVillage';
import CTFComingSoon from './components/Sections/CTFComingSoon';
import TicketSection from './components/Sections/TicketSection';
import Footer from './components/Layout/Footer';

function App() {
  React.useEffect(() => {
    const criticalStyles = document.createElement('style');
    criticalStyles.textContent = `
      body { 
        font-display: swap;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
      }
      .hero-section { 
        min-height: 100vh;
        background: linear-gradient(135deg, #0A1A2E 0%, #16213E 100%);
      }
    `;
    document.head.appendChild(criticalStyles);

    // Preload critical images
    const heroImage = new Image();
    heroImage.src = '/heroimage.png';
    
    const logo = new Image();
    logo.src = '/bsidesabq.png';
  }, []);

  return (
    <LightweightPerformanceProvider>
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <NavigationProvider>
          <PageWrapper>
            <Header />
            <Hero />
            <Countdown />
            <TicketSection />
            <About />
            <Speakers />
            <CTFComingSoon />
            <Sponsors />
            <HackingVillage />
            <EventDetails />
            <Footer />
          </PageWrapper>
        </NavigationProvider>
      </ThemeProvider>
    </LightweightPerformanceProvider>
  );
}

export default App;